<!-- Start Navbar Area -->
<div class="navbar-area" [class.is-sticky]="isSticky">
  <div class="navbar-container">
    <nav class="navbar">
      <!-- <div class="navbar-brand">
        <a routerLink="/">
          <img src="assets/img/kmlogo1.png" alt="Kitchen Magic">
        </a>
      </div> -->

      <!-- <div class="navbar-brand">
  <a routerLink="/">
    <div class="logo-wrapper">
      <img src="assets/img/kmlogo1.png" alt="Kitchen Magic">

      <span class="spark s1"></span>
      <span class="spark s2"></span>
      <span class="spark s3"></span>
      <span class="spark s4"></span>
      <span class="spark s5"></span>
      <span class="spark s6"></span>
      <span class="spark s7"></span>
      <span class="spark s8"></span>
    </div>
  </a>
</div> -->


      <div class="navbar-brand">
  <a routerLink="/">
    <div class="logo-container">

      <img
        #logo
        src="assets/img/kmlogo1.png"
        alt="Kitchen Magic"
      >

      <div class="orbit">
        <div class="comet"></div>
      </div>

      <canvas #particles class="particleCanvas"></canvas>

    </div>
  </a>
</div>

      <div class="navbar-menu">
        <ul class="nav-list">
          <li class="nav-item"><a routerLink="/" class="nav-link">Home</a></li>
          <li class="nav-item"><a routerLink="/about" class="nav-link">About Us</a></li>
          <li class="nav-item"><a routerLink="/product-menu" class="nav-link">Menu</a></li> 
          <li class="nav-item"><a routerLink="/catering" class="nav-link">Catering</a></li>
          <li class="nav-item"><a routerLink="/blog-grid" class="nav-link">Blog</a></li>
          <li class="nav-item"><a routerLink="/contact" class="nav-link">Contact Us</a></li>
        </ul>
      </div>

      <div class="navbar-actions">
        <button class="action-btn cart-btn" (click)="goToCart()">
          <i class='bx bx-cart'></i>
          <span class="cart-count" *ngIf="cartItemCount > 0">{{cartItemCount}}</span>
        </button>

        <a href="tel:+16698710461" class="phone-btn">
          <i class='bx bx-phone'></i>
          <span>‎+1 (669) 871-0461</span>
        </a>

        <div class="user-section" *ngIf="isLoggedIn(); else guestLinks">
          <div class="user-pill">
            <!-- <a routerLink="/user-profile" class="avatar">{{ getUserName().charAt(0) }}</a> -->
             <a routerLink="/user-profile" class="avatar">

              <!-- Show profile image -->
              <img
                *ngIf="getUserImage(); else defaultAvatar"
                [src]="getUserImage()"
                [alt]="getUserName()"
                class="avatar-img"
              />

              <!-- Fallback -->
              <ng-template #defaultAvatar>
                {{ getUserName().charAt(0) | uppercase }}
              </ng-template>

            </a>
            <div class="user-dropdown">
              <span class="username">Hi, {{ getUserName() }}</span>
              <button class="logout-btn" (click)="logout()">Logout</button>
            </div>
          </div>
        </div>

        <ng-template #guestLinks>
          <a routerLink="/profile-authentication">
            <button class="action-btn login-btn" (click)="openLogin()">Login</button>
          </a>
        </ng-template>

        <button class="action-btn menu-btn" (click)="toggleMobileMenu()">
          <i class='bx bx-menu'></i>
        </button>
      </div>
    </nav>
  </div>
</div>
<!-- End Navbar Area -->

<!-- Mobile Menu Overlay -->
<div class="mobile-menu-overlay" [class.active]="isMobileMenuOpen" (click)="closeMobileMenu()">
  <div class="mobile-menu-content" (click)="$event.stopPropagation()">
    <button class="mobile-menu-close" (click)="closeMobileMenu()">
      <i class='bx bx-x'></i>
    </button>

    <ul class="mobile-nav-list">
      <li class="mobile-nav-item">
        <a routerLink="/" class="mobile-nav-link" (click)="closeMobileMenu()">Home</a>
      </li>
      <li class="mobile-nav-item">
        <a routerLink="/about" class="mobile-nav-link" (click)="closeMobileMenu()">About Us</a>
      </li>
      <li class="mobile-nav-item">
        <a routerLink="/product-menu" class="mobile-nav-link" (click)="closeMobileMenu()">Menu</a>
      </li>
       <li class="mobile-nav-item">
        <a routerLink="/catering" class="mobile-nav-link" (click)="closeMobileMenu()">Catering</a>
      </li> 
      <li class="mobile-nav-item">
        <a routerLink="/blog-grid" class="mobile-nav-link" (click)="closeMobileMenu()">Blog</a>
      </li>
      <li class="mobile-nav-item">
        <a routerLink="/contact" class="mobile-nav-link" (click)="closeMobileMenu()">Contact Us</a>
      </li>
    </ul>
  </div>
</div>

<app-checkout-modal [show]="showCheckout" [orderData]="orderData" (close)="showCheckout=false">
</app-checkout-modal>
